import {Box, ChipProps, Stack, SxProps, Tooltip} from "@mui/material";
import React, {useMemo} from "react";
import KeyIcon from "@mui/icons-material/Key";
import {KeyTagChip} from "../key-tag-chip/KeyTagChip";
import {noop} from "../../util/FunctionUtil";
import {KeyData, KeyHistoryRecord} from "../../api/Model";
import {ColorChip} from "../color-chip/ColorChip";
import {KeyVaultChip} from "../key-vault-chip/KeyVaultChip";

function KeyChipTooltip({keyData, record}: {
    keyData: KeyData,
    record?: KeyHistoryRecord,
}) {
    return (
        <Stack direction="column" spacing={1} sx={{m: 1}}>
            {record?.vault && (
                <Stack direction="row" alignItems="baseline" spacing={2}>
                    <Box>Vault</Box>
                    <KeyVaultChip keyVault={record.vault} clickable={false} size="small"/>
                </Stack>
            )}
            {record?.from && (
                <Stack direction="row" spacing={2}>
                    <Box>Since</Box>
                    <Box>{record.from}</Box>
                </Stack>
            )}
            {keyData.transponderId && (
                <Stack direction="row" spacing={2}>
                    <Box>NFC</Box>
                    <Box>{keyData.transponderId}</Box>
                </Stack>
            )}
            {record?.notes && (
                <Stack direction="row" spacing={2}>
                    <Box>Notes</Box>
                    <Box>{record.notes}</Box>
                </Stack>
            )}
            {keyData.tags.map(keyTag => (
                <Stack key={keyTag.id} direction="row" alignItems="center" spacing={2}>
                    <KeyTagChip key={keyTag.id} keyTag={keyTag} size="small"/>
                    {keyTag.description && (
                        <Box>{keyTag.description}</Box>
                    )}
                </Stack>
            ))}
        </Stack>
    )
}

export function KeyChip({keyData, record, ...props}: {
    keyData: KeyData,
    record?: KeyHistoryRecord,
} & ChipProps) {
    const tags = keyData.tags;
    const tagStyle = useMemo<SxProps | undefined>(
        () => (tags.length > 0 ? {
            boxShadow: tags.map((tag, index) => `0 0 0 ${(index + 1) * 2}px ${tag.color}`).join(','),
        } : undefined),
        [tags],
    );

    return (
        <Tooltip title={<KeyChipTooltip keyData={keyData} record={record}/>}>
            <ColorChip
                label={keyData.keyNumber}
                variant="filled"
                color={record?.vault.color}
                size="small"
                icon={<KeyIcon/>}
                onClick={noop}
                clickable={false}
                sx={tagStyle}
                {...props}
            />
        </Tooltip>
    );
}